module.exports = __webpack_public_path__ + "img/text-icon.fa6a121f.svg";